import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["countdown", "resendForm"];
  static values = {
    // Able to re-send code after 30 seconds
    cooldown: {type: Number, default: 30},
    key: String,
    sent: {type: Boolean, default: false},
    rateLimited: {type: Boolean, default: false},
    rateLimitSeconds: {type: Number, default: 60}
  };

  connect() {
    if (this.rateLimitedValue) {
      this.startRateLimitCooldown();
      return;
    }

    const lastSent = localStorage.getItem(this.storageKey);
    if (lastSent) {
      const elapsed = Math.floor((Date.now() - parseInt(lastSent, 10)) / 1000);
      const remaining = this.cooldownValue - elapsed;
      if (remaining > 0) {
        this.startCooldown(remaining);
      } else {
        localStorage.removeItem(this.storageKey);
      }
    } else if (this.sentValue) {
      localStorage.setItem(this.storageKey, Date.now().toString());
      this.startCooldown(this.cooldownValue);
    }
  }

  disconnect() {
    clearInterval(this.timer);
  }

  submit(event) {
    if (this.remaining > 0) {
      event.preventDefault();
      return;
    }

    localStorage.setItem(this.storageKey, Date.now().toString());
  }

  startRateLimitCooldown() {
    const rateLimitStart = localStorage.getItem(this.rateLimitStorageKey);
    let remaining;

    if (rateLimitStart) {
      const elapsed = Math.floor((Date.now() - parseInt(rateLimitStart, 10)) / 1000);
      remaining = this.rateLimitSecondsValue - elapsed;
    } else {
      localStorage.setItem(this.rateLimitStorageKey, Date.now().toString());
      remaining = this.rateLimitSecondsValue;
    }

    if (remaining > 0) {
      this.remaining = remaining;
      this.startTimer(this.rateLimitStorageKey, () => this.updateRateLimitDisplay());
    } else {
      localStorage.removeItem(this.rateLimitStorageKey);
    }
  }

  startCooldown(seconds) {
    this.remaining = seconds;
    this.startTimer(this.storageKey, () => this.updateDisplay());
  }

  startTimer(storageKey, displayFn) {
    displayFn();
    this.resendFormTarget.hidden = true;
    this.countdownTarget.style.padding = '0.375rem 0';

    this.timer = setInterval(() => {
      this.remaining--;
      displayFn();

      if (this.remaining <= 0) {
        clearInterval(this.timer);
        this.resendFormTarget.hidden = false;
        this.countdownTarget.textContent = '';
        this.countdownTarget.style.padding = '';
        localStorage.removeItem(storageKey);
      }
    }, 1000);
  }

  updateDisplay() {
    this.countdownTarget.textContent = `Resend code in ${this.remaining}s`;
  }

  updateRateLimitDisplay() {
    const minutes = Math.floor(this.remaining / 60);
    const seconds = this.remaining % 60;
    const timeStr = minutes > 0 ? `${minutes}:${seconds.toString().padStart(2, '0')}` : `${seconds}s`;
    this.countdownTarget.textContent = `Resend code in ${timeStr}`;
  }

  get storageKey() {
    return `otp_resend_${this.keyValue}`;
  }

  get rateLimitStorageKey() {
    return `otp_rate_limit_${this.keyValue}`;
  }
}
